module.exports = __webpack_public_path__ + "img/bnp.c8228788.svg";